import './banner.css'

import { ScrollPattern } from './ScrollPattern';

import { SparkleEffect } from './SparkleEffect';

import { Helmet } from 'react-helmet';

function Banner({image, height, title, description, textCol, textGradient, showEffects}){
    return(
      <div className="Banner" style={{height: height}}>
        {showEffects &&
          <div>
            <Helmet>
              <script type="text/javascript" src={`/GrowingBg.js?v=${new Date().getTime()}`} />
            </Helmet>
            <svg id="hearts" viewBox="-600 -400 1200 800" preserveAspectRatio="xMidYMid slice" style={{height: height}}>
              <defs>
                <symbol  id="heart" viewBox="-69 -16 138 138">
                <circle cx="" cy="50" r="50" />
                </symbol>
              </defs>
            </svg>
          </div>
        }
        {image && (
          <img src={image} alt="" style={{ height: height }} />
        )}
        {showEffects && <ScrollPattern />}
        <div class className="BannerTekst">
          <h1 style={{backgroundColor: textCol, backgroundImage: textGradient}}>{title}</h1>
          <p style={{color: textCol}}>{description}</p>
        </div>
      </div>
    );
}

export default Banner;